// @flow

import React from 'react';
import {
  getFormattedDate,
  getFormattedTime,
  getRetailTableCellObject,
  returnSubstring
} from '../../../services/helpers';
import { zoomTableActionsConfig } from '../../commons/zoomTable/zoomTableConfig';
import { RenderTableActionButtons } from '../../commons/tableActionButton/tableActionButton';

// assets import
const preview = require('../../../assets/images/view.svg');
const downloadImg = require('../../../assets/images/download-symbol.svg');
const editImg = require('../../../assets/images/ic_mode_edit_black_24px.svg');

export const NEW = 'NEW';
export const COMPLETED = 'CMS_COMPLETED';
export const StatusType = {
  ALL: 'ALL',
  DRAFTED: 'DRAFTED',
  DELIVERED: 'DELIVERED',
  PENDING: 'PENDING',
  FAILED: 'FAILED'
};

export const StatusTypeList = [
  { key: StatusType.ALL, val: 'ALL' },
  { key: StatusType.DELIVERED, val: StatusType.DELIVERED },
  { key: StatusType.DRAFTED, val: StatusType.DRAFTED },
  { key: StatusType.PENDING, val: StatusType.PENDING },
  { key: StatusType.FAILED, val: StatusType.FAILED }
];

export const SelectedTabType = {
  ZOOM_RETAIL: 'ZOOM_RETAIL',
  ZOOM_FRANCHISE: 'ZOOM_FRANCHISE',
  ZOOM_CORPORATE: 'ZOOM_CORPORATE'
};

export const cmsToolbarConfig = {
  display: ['INLINE_STYLE_BUTTONS', 'BLOCK_TYPE_BUTTONS'],
  INLINE_STYLE_BUTTONS: [
    {
      label: 'Bold',
      style: 'BOLD',
      className: 'custom-bold'
    },
    {
      label: 'Italic',
      style: 'ITALIC',
      className: 'custom-italic'
    },
    {
      label: 'Underline',
      style: 'UNDERLINE',
      className: 'custom-underline'
    }
  ],
  BLOCK_TYPE_BUTTONS: [
    {
      label: 'UL',
      style: 'unordered-list-item',
      className: 'custom-ul'
    },
    {
      label: 'OL',
      style: 'ordered-list-item',
      className: 'custom-ol'
    }
  ]
};

export const cmsCompletedTableConfig = {
  columns: [
    {
      Header: 'Serial No.',
      headerClassName: 'flex-10',
      className: 'table-cell-custom-retail flex-10',
      accessor: 'id',
      Cell: row => {
        return <div> {row.original.id}</div>;
      }
      // sortMethod: (a, b) => (a.toLowerCase() > b.toLowerCase() ? 1 : -1)
    },
    {
      Header: 'Initiate Date',
      headerClassName: 'flex-15',
      className: 'table-cell-custom-retail flex-15',
      accessor: 'actionTakenAt',
      Cell: row =>
        getRetailTableCellObject(
          getFormattedDate(row.original.createdAt),
          getFormattedTime(row.original.createdAt)
        )
      // sortMethod: (a, b) => (a.toLowerCase() > b.toLowerCase() ? 1 : -1)
    },
    {
      Header: 'Last Updated At',
      headerClassName: 'flex-15',
      className: 'table-cell-custom-retail flex-15',
      accessor: 'actionTakenAt',
      Cell: row => {
        return row.original.communicationStatus === StatusType.DRAFTED ? (
          <div>-</div>
        ) : (
          getRetailTableCellObject(
            getFormattedDate(row.original.actionTakenAt),
            getFormattedTime(row.original.actionTakenAt)
          )
        );
      }

      // sortMethod: (a, b) => (a.toLowerCase() > b.toLowerCase() ? 1 : -1)
    },
    {
      Header: 'Client Group',
      headerClassName: 'flex-15',
      className: 'table-cell-custom-retail flex-15 client-col',
      accessor: 'serviceTypeList',
      Cell: row => {
        return (
          <div>
            {row.original.serviceTypeList.map(serviceType => (
              <div key={serviceType}>{serviceType}</div>
            ))}
          </div>
        );
      }
      // sortMethod: (a, b) => (a > b ? 1 : -1)
    },
    {
      Header: 'Subject',
      headerClassName: 'flex-15',
      className: 'table-cell-custom-retail flex-15',
      accessor: 'subject',
      Cell: row => (
        <div>
          {/* {row.original.subject
            ? returnSubstring(row.original.subject, '--')
            : '--'} */}
          {returnSubstring(row.original.subject, '--')}
        </div>
      )
      // sortMethod: (a, b) => (a > b ? 1 : -1)
    },
    {
      Header: 'Status',
      headerClassName: 'flex-15',
      className: 'table-cell-custom-retail flex-15 status-col',
      accessor: 'statusWiseCount',
      Cell: row => {
        const statusWiseCount = row.value;
        const statusLabels = Object.keys(statusWiseCount)
          .map(status => {
            let label = '';
            if (status === 'DRAFTED') {
              // label = `DR: ${statusWiseCount[status]}`;
            } else if (status === 'FAILED') {
              label = `F: ${statusWiseCount[status]}`;
            } else if (status === 'DELIVERED') {
              label = `D: ${statusWiseCount[status]}`;
            } else if (status === 'PENDING') {
              label = `P: ${statusWiseCount[status]}`;
            }
            return label;
          })
          .filter(label => label)
          .join(' | ');

        return (
          <div>
            <div>{row.original.communicationStatus}</div>
            {row.original &&
              row.original.communicationStatus &&
              row.original.communicationStatus !== 'DRAFTED' && (
                <span>{statusLabels || '-'}</span>
              )}
          </div>
        );
      }
    },
    {
      Header: 'Last Updated By',
      headerClassName: 'flex-15',
      className: 'table-cell-custom-retail flex-15',
      accessor: 'actionTakenBy',
      // Cell: row => <div>{row.original.actionTakenBy}</div>,
      Cell: row => {
        return row.original.communicationStatus === StatusType.DRAFTED ? (
          <div>-</div>
        ) : (
          <div>{row.original.actionTakenBy}</div>
        );
      },
      sortMethod: (a, b) => (a > b ? 1 : -1)
    },
    {
      Header: 'Actions',
      headerClassName: 'flex-15',

      className: 'flex-15 rt-td table-cell-custom-retail',
      width: 450,
      maxWidth: 150,
      sortable: false,
      Cell: obj => (
        <RenderTableActionButtons
          rowData={obj.original || {}}
          buttonConfig={cmsTableActionsConfig.buttons}
        />
      )
    }
  ],
  className: 'zoomTableLegacyWrapper',
  noDataText: 'No data found',
  minRows: 1,
  pageSizeOptions: [7, 10, 15, 25, 50, 100],
  style: { maxHeight: 'calc(100vh - 22rem)' }
};

export const cmsTableActionsConfig = {
  buttons: [
    {
      label: 'preview',
      iconOnly: true,
      iconRef: preview,
      onClick: rowData => {
        if (
          zoomTableActionsConfig.CMS_COMPLETED.actions &&
          zoomTableActionsConfig.CMS_COMPLETED.actions.openPreviewModal
        ) {
          zoomTableActionsConfig.CMS_COMPLETED.actions.openPreviewModal(
            rowData
          );
        }
      },
      style: {
        width: '40px',
        height: '40px',
        margin: '2%'
      }
    },
    {
      label: 'edit',
      iconOnly: true,
      iconRef: editImg,
      onClick: rowData => {
        if (
          zoomTableActionsConfig.CMS_COMPLETED.actions &&
          zoomTableActionsConfig.CMS_COMPLETED.actions.openEditModal
        ) {
          zoomTableActionsConfig.CMS_COMPLETED.actions.openEditModal(rowData);
        }
      },
      hide: rowData =>
        rowData &&
        rowData.communicationStatus &&
        rowData.communicationStatus !== 'DRAFTED',
      style: {
        // width: '40px',
        height: '40px'
        // margin: '2%'
      }
    },
    {
      label: 'download',
      iconOnly: true,
      iconRef: downloadImg,
      onClick: rowData => {
        if (
          zoomTableActionsConfig.CMS_COMPLETED.actions &&
          zoomTableActionsConfig.CMS_COMPLETED.actions.downloadCSVFnc
        ) {
          zoomTableActionsConfig.CMS_COMPLETED.actions.downloadCSVFnc(rowData);
        }
      },
      hide: rowData =>
        rowData &&
        rowData.communicationStatus &&
        rowData.communicationStatus === 'DRAFTED',
      style: {
        // width: '40px',
        height: '40px'
        // margin: '2%'
      }
    }
  ]
};
